<template>
  <a-modal v-model="modal" title="请编辑领料单" width="1000px" :maskClosable="false">
    <div class="merge-material-modal-css">
      <div class="example" v-if="loading">
        <a-spin />
      </div>
      <div v-for="(item, index) in dataList" :key="item.id + index" class="merge-material" v-show="!loading">
        <table border="1" class="table-style" width="100%">
          <tr>
            <td class="tac print-title" colspan="5">领料单号：{{ item.billNo }}</td>
          </tr>
          <tr>
            <td class="tac table-title">MO票号</td>
            <td class="tac mo-ticket-codes" colspan="3">{{ item.moTicketCodes }}</td>
            <td class="tac">
              <QrCode class="qr-code" id="moBillNoQrCode1" :text="item.billNo" width="130" height="130" />
            </td>
          </tr>
          <tr>
            <td class="tac table-title" width="13%">物料编码</td>
            <td class="tac table-title">物料名称</td>
            <td class="tac table-title" width="16%">合计</td>
            <td class="tac table-title" width="17%">领料数量</td>
            <td class="tac table-title" width="17%">补料数量</td>
          </tr>
          <tr v-if="!item.detailList || item.detailList.length===0">
            <td class="tac" colspan="5">空</td>
          </tr>
          <tr v-for="(material, materialIndex) in item.detailList" :key="material.itemCode + materialIndex">
            <td class="tac">{{ material.itemCode }}</td>
            <td class="tac" >{{ material.itemName }}</td>
            <td class="tac">{{ material.requisitionQuantity }}</td>
            <td class="tac">
              <a-input-number
                style="width: 100%;"
                v-model="material.llsl"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :min="0"
                placeholder="请输入" />
            </td>
            <td class="tac">
              <a-input-number
                style="width: 100%;"
                v-model="material.blsl"
                :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                :min="0"
                placeholder="请输入" />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">备注</td>
            <td class="tac" colspan="4">
              <a-input type="textarea" :autoSize="{minRows:2}" v-model="item.remark" placeholder="请输入" allowClear />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">退料</td>
            <td class="tac">
              <a-input v-model="item.tbl" placeholder="请输入" allowClear />
            </td>
            <td class="tac table-title">真皮批次</td>
            <td class="tac" colspan="2">
              <a-input v-model="item.zppc" placeholder="请输入" allowClear />
            </td>
          </tr>
          <tr>
            <td class="tac table-title" colspan="5">
              <div class="info">
                <div class="item">仓库主管:</div>
                <div class="item">车间主管:</div>
                <div class="item">收货人:</div>
              </div>
            </td>
          </tr>
        </table>
        <div class="text-line" v-if="dataList.length>1">
          <span>第{{ index + 1 }}单&nbsp;&nbsp;共{{ dataList.length }}单</span>
        </div>
      </div>
      <div class="display-none">
        <PrintMergeMaterial ref="printMergeMaterialRef" id="moPrintMergeMaterialId" />
      </div>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;">取消</a-button>
        <a-button type="primary" @click="toPrint" :loading="btnLoading||loading">确认打印</a-button>
        <a-button ref="moPrintMergeMaterialBtn" v-show="false" v-print="'#moPrintMergeMaterialId'">打印领料单</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import PrintMergeMaterial from './print-merge-material'
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep'
import QrCode from '@/components/QrCode/index.vue'
import {
  apiGetMaterialPrintListMerge
} from '@/api/mes/workOrderManage/moTickets'
export default {
  name: 'PrintMergeMaterialModal',
  components: {
    QrCode,
    PrintMergeMaterial
  },
  data () {
    return {
      dataList: [],
      modal: false,
      loading: false,
      btnLoading: false,
      selectRow: []
    }
  },
  methods: {
    moment,
    // 每行派工数据合计,简单处理精度问题
    onBlurPgsl(data) {
      const total = Number(data.planQuantity || 0) * Number(data.quantityPerAssembly || 0)
      data.hj = Math.round(total * 100) / 100
      this.$forceUpdate()
    },
    show(selectRow) {
      this.selectRow = selectRow
      this.getData()
      this.modal = true
    },
    // 打印领料单
    toPrint() {
      this.$refs.printMergeMaterialRef.show(cloneDeep(this.dataList))
      setTimeout(() => {
        this.$refs.moPrintMergeMaterialBtn.$el.dispatchEvent(new MouseEvent("click"))
      }, 200)
    },
    // 获取数据
    getData() {
      this.dataList = []
      this.loading = true
      apiGetMaterialPrintListMerge(this.selectRow.map(v => v.id)).then(res => {
        if (res?.data?.length > 0) {
          this.dataList = res.data
          this.dataList.forEach(item => {
            if(item?.detailList?.length > 0) {
              item.detailList.forEach(material => {
                this.onBlurPgsl(material)
              })
            }
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.merge-material-modal-css{
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  padding: 0 15px;
  font-size: 15px;
}
.example {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 30px 50px;
  margin: 20px 0;
}
.merge-material{
  margin: 10px auto 20px auto;
}
.display-none {
  display: none
}
.info{
  display: flex;
  justify-content: space-between;
  .item{
    text-align: left;
    padding-left: 4.2%;
    width: 33%;
  }
}
.print-title{
  font-weight: 600;
  font-size: 16px;
}
.table-title{
  font-weight: 600;
  font-size: 15px;
}
.table-style{
  width: 100%;
}
.tac{
  text-align: center;
}
tr{
  height: 30px;
}
td{
  padding: 0 5px;
}
.text-line {
  text-align: center;
  position: relative;
  margin: 20px 0;
  height: 20px; /* 文本上下间距 */
}

.text-line span {
  font-style: italic;
  background-color: white; /* 与背景颜色相同以覆盖分割线 */
  padding: 0 10px; /* 文本左右间距 */
  position: absolute;
  left: 47%;
  transform: translateX(-50%);
  top: 50%;
  transform: translateY(-50%);
  color: #333; /* 文本颜色 */
}

.text-line::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 1px;
  background-color: #9a9a9a;
}
.mo-ticket-codes {
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}
/deep/.qr-code {
  margin: 2px 0;
  img {
    margin: auto;
  }
}
</style>
